import React from 'react';

// Total Players - two people
export const PlayersIcon = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="7" r="3.5" stroke={color} strokeWidth="2"/>
    <path d="M3 19v-1c0-2.21 2.69-4 6-4s6 1.79 6 4v1" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <circle cx="17" cy="8" r="2.5" stroke={color} strokeWidth="2"/>
    <path d="M17 13c1.93 0 3.5 1.12 3.5 2.5V17" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Total Tournaments - trophy
export const TrophyIcon = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 21h8M12 17v4M7 4h10v5c0 2.76-2.24 5-5 5s-5-2.24-5-5V4z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7 7H4c0 2.5 1.5 4 3 4M17 7h3c0 2.5-1.5 4-3 4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Total Matches - two paddles facing each other (VS)
export const MatchIcon = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="7" cy="8" rx="4" ry="5" stroke={color} strokeWidth="2" transform="rotate(-20 7 8)"/>
    <path d="M5 12l-2 6" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <ellipse cx="17" cy="8" rx="4" ry="5" stroke={color} strokeWidth="2" transform="rotate(20 17 8)"/>
    <path d="M19 12l2 6" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <text x="12" y="22" textAnchor="middle" fill={color} fontSize="8" fontWeight="bold">VS</text>
  </svg>
);

// Average Elo - chart trending up
export const ChartIcon = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 3v18h18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7 14l4-4 4 4 5-6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Highest Elo Ever - mountain peak with flag
export const PeakIcon = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 4v6" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 4l4 3-4 1" fill={color} stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M3 20l6-8 3 4 4-6 5 10H3z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Most Tournaments Won - trophy with star
export const ChampionIcon = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 21h8M12 17v4M7 4h10v5c0 2.76-2.24 5-5 5s-5-2.24-5-5V4z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7 7H4c0 2.5 1.5 4 3 4M17 7h3c0 2.5-1.5 4-3 4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 6l.9 1.8 2 .3-1.45 1.4.35 2-1.8-.95-1.8.95.35-2-1.45-1.4 2-.3L12 6z" fill={color}/>
  </svg>
);

// Most Tournaments Played - calendar with checkmarks
export const ParticipationIcon = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="18" height="17" rx="2" stroke={color} strokeWidth="2"/>
    <path d="M3 9h18" stroke={color} strokeWidth="2"/>
    <path d="M8 2v4M16 2v4" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M7 13l2 2 3-4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 14h3M14 17h3" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Sets Played - scoreboard
export const ScoreboardIcon = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="5" width="18" height="14" rx="2" stroke={color} strokeWidth="2"/>
    <path d="M12 5v14" stroke={color} strokeWidth="2"/>
    <text x="7.5" y="15" textAnchor="middle" fill={color} fontSize="8" fontWeight="bold">3</text>
    <text x="16.5" y="15" textAnchor="middle" fill={color} fontSize="8" fontWeight="bold">2</text>
  </svg>
);

// Points Played - simple ping pong ball
export const BallIcon = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" fill={color}/>
    <path d="M6 8c2 2 4 3 6 3s4-1 6-3" stroke="rgba(0,0,0,0.15)" strokeWidth="1.5" fill="none"/>
  </svg>
);
